import { ChangeDetectionStrategy, Component, Input, OnInit, signal } from '@angular/core';
import { Area, BusinessProcess, Process } from 'app/api';
import { VerifyService } from 'app/modules/verify/verify.service';
import { ViewService } from 'app/modules/view/view.service';
import { NewMDOService } from 'app/services/new_mdo.service';
import { PrintViewComponent } from '../print-view.component';

@Component({
    selector: 'print-view',
    templateUrl: './bp-print-view.component.html',
    styleUrls: ['../print-view.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class BpPrintViewComponent extends PrintViewComponent implements OnInit {
    /**
     * The BusinessProcess that contains the tasks
     */
    @Input() businessProcess: BusinessProcess;
    /**
     * The process that contains the details and the description
     */
    @Input() process?: Process;
    /**
     * The service that is needed for FlowchartContainerComponent. Either ViewService or VerifyService.
     */
    @Input() service: ViewService | VerifyService;

    @Input() image: any;

    @Input() images: any[];

    @Input() taskDescription: 'instructions' | 'description' = 'description';

    /**
     * The signal used to execute actions
     */
    executeActionSignal = signal(null);

    constructor(private _newMdoService: NewMDOService) {
        super();
    }
    ngOnInit(): void {
        const owner = this._newMdoService.usersForSelect.find(
            owner => owner.value === this.process.ownerid
        );
        this.process.owner = owner.label;

        const area: Area = this.findDeep(this.process.area, this._newMdoService.areas());
        this.process.area = area.title;
    }

    private findDeep(id: string, items: any[]): any {
        let versionId: string;
        if (id.includes('_')) {
            versionId = id.split('_')[0];
            id = id.split('_')[1];
        }

        for (let item of items) {
            if (versionId && item['versionId'] && item['versionId'] !== versionId) {
                continue;
            }

            if (item['id'] === id) return item;

            if (item['children']?.length > 0) {
                let subItem = this.findDeep(id, item['children']);
                if (subItem) return subItem;
            }
        }
        return null;
    }

    static override print(title: string): void {
        setTimeout(() => {
            const print = this.printContextInNewWindow(title);

            print.newWindow.onafterprint = () => {
                print.newWindow.close();
            };
        }, 100);
    }

    trackByFn(index: number, item: any) {
        return item || index;
    }
    trackById(index: number, item: any) {
        return item.id || index;
    }
}
